module.exports = __webpack_public_path__ + "static/img/g_hands.1be91534.webp";